import alert from '@/assets/sounds/graceful.mp3'
import signaling from '@/assets/sounds/signaling.wav'

class AudioManager {
    constructor(audioInstance) {
        this.audio = audioInstance
        this.isPlaying = false
    }

    play() {
        if (this.isPlaying) {
            return
        }

        this.audio.play()
            .then(() => {
                this.isPlaying = true
            }).catch((err) => {
                console.log(err)
            })
    }

    stop() {
        this.audio.pause()
        this.audio.currentTime = 0
        this.isPlaying = false
    }

    reset() {
        if (this.isPlaying) {
            this.audio.currentTime = 0
        }
    }
}

function createAudio(path) {
    return new Audio(path)
}

const signalingManager = new AudioManager(createAudio(signaling))
const alertManager = new AudioManager(createAudio(alert))

export {
    signalingManager,
    alertManager,
}
